import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MeetingService } from '../../services/meeting.service';
import { EmailValidator } from '../validators/email_validator';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CookieService } from 'angular2-cookie/services/cookies.service';

@Component({
  selector: 'app-needhelp',
  templateUrl: './needhelp.component.html',
  styleUrls: ['./needhelp.component.css']
})
export class NeedhelpComponent {

  busy: Promise<any>;
  person: any = {};
  helpform: FormGroup;
  submitAttempt: boolean;
  authcode: any;
  result: any;

  constructor(
    public meetingService: MeetingService,
    private _cookieService: CookieService,
    public router: Router,
    public formBuilder: FormBuilder) {

    this.helpform = formBuilder.group({
        email: ['', Validators.compose([Validators.required, EmailValidator.isValid])]
    });
  }

  getHelp() {
    this.submitAttempt = true;
    if (!this.helpform.valid) {
        // console.log("not valid");
    } else {
      // console.log(this.person.email);
      const object = 'Users';
      const action = 'forgot';
      this.busy = this.meetingService.forgetPass(object, action, this.person.email).subscribe(response => {
        if (response) {
          // console.log(response);
          // this._flashMessagesService.show(response.message , { cssClass: 'alert-success', timeout: 15000 });
          // let link = ['/login'];
          // this.router.navigate(link);
          if (response.success === 1) {
            this._cookieService.put('msg', response.message);
            const link = ['/login'];
            this.router.navigate(link);
          } else {
            this._cookieService.put('e_msg', response.message);
            const link = ['/login'];
            this.router.navigate(link);
          }
          // var msg = this._cookieService.get('message');
          // // console.log(msg);
          // window.location.href = "http://ovo.dev.bluelightit.com/";
        } else {
          // console.log("error");
        }
      });
    }
  }

}
